import { BadgeCheck } from "lucide-react";

export const DealerBadge = ({ className = "", size = "sm", label = true }) => {
  const dims = size === "lg" ? "w-5 h-5" : "w-3.5 h-3.5";
  const text = size === "lg" ? "text-xs" : "text-[10px]";
  return (
    <span data-testid="dealer-badge" className={`inline-flex items-center gap-1 text-blaze font-bold uppercase tracking-wider ${text} ${className}`}>
      <BadgeCheck className={dims} strokeWidth={2.5} />
      {label && "Verified Dealer"}
    </span>
  );
};
